import React, { useEffect, useRef } from "react";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";


const MongoDBChart = ({ dashboardId, baseUri, token, filter, preFilter }) => {
	const chartRef = useRef();

	useEffect(() => {
		if (!token || !dashboardId || !baseUri) return;

		async function renderDashboard() {
			const sdk = new ChartsEmbedSDK({
				baseUrl: baseUri,
				dashboardId: dashboardId,
				getUserToken: () => token,
			});

			const chart = sdk.createChart({
				chartId: dashboardId,
				theme: 'light',
				height: "100%",
				width: '100%',
				widthMode: 'scale',
				filter,
				preFilter,
				showAttribution: false,
			});

			try {
				await chart.render(chartRef.current);
			} catch (e) {
				console.error("Chart render error:", e);
			}
		}

		renderDashboard();
	}, [dashboardId, baseUri, token, filter, preFilter]);


	return (

		<div ref={chartRef} style={{ height: "100%", width: "100%" }} />

	);
};

export default MongoDBChart;

